import React from "react";
import footerLogo from "../../../assets/images/footer_logo.png";

import {
  MdCall,
  MdMail,
  MdLocationOn,
  MdLanguage,
  MdShare,
} from "react-icons/md";
import styles from "./Footer.module.css";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Image } from "react-bootstrap";

export default function Footer() {
  const basePath = process.env.REACT_APP_BASE_PATH;
  return (
    <footer className={styles.footer}>
      {/* Upper Footer Links */}
      <div className={styles.topContainer}>
        {/* Brand Cell */}
        <div className={styles.brandCol}>
          <div className={styles.logo}>
            <Image src={footerLogo} />
          </div>
          <p className={styles.brandPitch}>
            India's leading industrial automotive parts distribution network for
            tyres, batteries, and genuine spares.
          </p>
          <div className={styles.socialRow}>
            <a
              href="#"
              className={styles.socialLink}
              aria-label="Language options"
            >
              <FaFacebookF />
            </a>
            <a
              href="#"
              className={styles.socialLink}
              aria-label="Share options"
            >
              <FaInstagram />
            </a>
            <a
              href="#"
              className={styles.socialLink}
              aria-label="Share options"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
        {/* Column 2 */}
        <div className={styles.col}>
          <h4 className={styles.colTitle}>Quick Links</h4>
          <ul className={styles.linkList}>
            <li>
              <a href="/" className={styles.link}>
                Tyres
              </a>
            </li>
            <li>
              <a href="/batteries" className={styles.link}>
                Battery
              </a>
            </li>
            <li>
              <a href="/servicesandrepair" className={styles.link}>
                Services and Repair
              </a>
            </li>
            <li>
              <a href="/contact-us" className={styles.link}>
                Contact us
              </a>
            </li>
          </ul>
        </div>
        {/* Terms and Conditions Privacy Policy Return and Refund Policy Shipping
        and Delivery Policy Download POS App */}
        {/* Column 3 */}
        <div className={styles.col}>
          <h4 className={styles.colTitle}>Branch Info</h4>
          <ul className={styles.linkList}>
            <li>
              <a href={`${basePath}findservicepoints`} className={styles.link}>
                Find a Store
              </a>
            </li>

            <li>
              <a href="/refund-return-policy" className={styles.link}>
                Return and Refund Policy
              </a>
            </li>
            <li>
              <a href="/shipping-and-delivery-policy" className={styles.link}>
                Shipping and Delivery Policy
              </a>
            </li>
            <li>
              <a
                href="https://play.google.com/store/apps/details?id=com.mechmilespos.app"
                className={styles.link}
              >
                Download POS App
              </a>
            </li>
          </ul>
        </div>
        {/* Column 4 */}
        <div className={styles.col}>
          <h4 className={styles.colTitle}>Contact</h4>
          <div className={styles.contactList}>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}>
                <MdCall size={20} />
              </span>
              <a href="tel:+917977016395" className="footer-phone-text">
                Contact us at: +91 7977016395
              </a>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}>
                <MdMail size={20} />
              </span>
              <a href="mailto:Info@mechmiles.com" className="footer-phone-text">
                Email us at: Info@mechmiles.com
              </a>
            </div>
            <div className={styles.contactItem}>
              <span className={styles.contactIcon}>
                <MdLocationOn size={20} />
              </span>
              <span>
                Corporate Address : Junction of Tyres Private Limited 101, 2nd
                Avenue, Atul Projects, Subhash Nagar ,Andheri (E) Mumbai-400093
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Under Footer copyright bar */}
      <div className={styles.bottomBar}>
        <div className={styles.bottomBarContent}>
          <span className={styles.copyright}>
            © {new Date().getFullYear()} Mechmiles Industrial Distribution. All
            rights reserved.
          </span>
          <div className={styles.legalRow}>
            <a href="/privacy" className={styles.legalLink}>
              Privacy Policy
            </a>
            <a href="/terms" className={styles.legalLink}>
              Terms and Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
